import Terrain from './Terrain.vue';

export default Terrain;
